import { defineRecipe, type SystemStyleObject } from '@chakra-ui/react/styled-system';

const selected: SystemStyleObject = {
  background: 'background/selected',
  borderColor: 'border/selected',
  color: 'icon/interactive',
};

const selectedHover: SystemStyleObject = {
  background: 'background/selected-hover',
  borderColor: 'border/selected',
  color: 'icon/interactive-hover',
};

const selectedActive: SystemStyleObject = {
  background: 'background/selected-active',
  borderColor: 'border/selected',
  color: 'icon/interactive-hover',
};

const active: SystemStyleObject = {
  background: 'button/secondary/bg-active',
  borderColor: 'button/secondary/border-active',
  color: 'button/secondary/icon-active',
};

const disabled: SystemStyleObject = {
  background: 'button/secondary/bg-disabled',
  borderColor: 'button/secondary/border-disabled',
  color: 'button/secondary/icon-disabled',
};

const toggleButtonRecipe = defineRecipe({
  className: 'toggle-button',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4',
    cursor: 'pointer',
    borderWidth: '1',
    background: 'button/secondary/bg',
    borderColor: 'button/secondary/border',
    color: 'button/secondary/icon',
    _hover: {
      background: 'button/secondary/bg-hover',
      borderColor: 'button/secondary/border-hover',
      _active: active,
      _pressed: {
        ...selectedHover,
        _active: selectedActive,
      },
    },
    _active: active,
    _pressed: {
      ...selected,
      _active: selectedActive,
    },
    _disabled: {
      cursor: 'not-allowed',
      ...disabled,
      _pressed: disabled,
    },
  },
  variants: {
    size: {
      sm: { padding: '8' },
      md: { padding: '12' },
      lg: { padding: '12' },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export default toggleButtonRecipe;
